"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ramda_1 = require("ramda");
const filterDateTime = ({ _eq, _gt, _lt }, dateTime) => {
    if (_eq) {
        return ramda_1.equals(new Date(_eq), new Date(dateTime));
    }
    if (_lt) {
        return new Date(dateTime) < new Date(_lt);
    }
    if (_gt) {
        return new Date(dateTime) > new Date(_gt);
    }
    return false;
};
exports.vlDateTimeFilter = {
    name: "VLDateTimeFilter",
    sdl: `
    input VLDateTimeFilter {
      _eq: String
      _gt: String
      _lt: String
    }
  `,
    filterFunction: filterDateTime,
};
exports.vlDateFilter = {
    name: "VLDateFilter",
    sdl: `
    input VLDateFilter {
      _eq: String
      _gt: String
      _lt: String
    }
  `,
    filterFunction: filterDateTime,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0ZUZpbHRlcnMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY21zL2ZpbHRlcnMvZGF0ZUZpbHRlcnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxpQ0FBK0I7QUFTL0IsTUFBTSxjQUFjLEdBQUcsQ0FBQyxFQUFFLEdBQUcsRUFBRSxHQUFHLEVBQUUsR0FBRyxFQUFnQixFQUFFLFFBQWdCLEVBQUUsRUFBRTtJQUMzRSxJQUFJLEdBQUcsRUFBRTtRQUNQLE9BQU8sY0FBTSxDQUFDLElBQUksSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFFLElBQUksSUFBSSxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUM7S0FDbEQ7SUFDRCxJQUFJLEdBQUcsRUFBRTtRQUNQLE9BQU8sSUFBSSxJQUFJLENBQUMsUUFBUSxDQUFDLEdBQUcsSUFBSSxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUM7S0FDM0M7SUFDRCxJQUFJLEdBQUcsRUFBRTtRQUNQLE9BQU8sSUFBSSxJQUFJLENBQUMsUUFBUSxDQUFDLEdBQUcsSUFBSSxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUM7S0FDM0M7SUFDRCxPQUFPLEtBQUssQ0FBQztBQUNmLENBQUMsQ0FBQztBQUVXLFFBQUEsZ0JBQWdCLEdBQXVDO0lBQ2xFLElBQUksRUFBRSxrQkFBa0I7SUFDeEIsR0FBRyxFQUFFOzs7Ozs7R0FNSjtJQUNELGNBQWMsRUFBRSxjQUFjO0NBQy9CLENBQUM7QUFFVyxRQUFBLFlBQVksR0FBdUM7SUFDOUQsSUFBSSxFQUFFLGNBQWM7SUFDcEIsR0FBRyxFQUFFOzs7Ozs7R0FNSjtJQUNELGNBQWMsRUFBRSxjQUFjO0NBQy9CLENBQUMifQ==